import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {MainComponent} from '@modules/main/main.component';
import {BlankComponent} from '@pages/blank/blank.component';
import {LoginComponent} from '@modules/login/login.component';
import {ProfileComponent} from '@pages/profile/profile.component';
import {RegisterComponent} from '@modules/register/register.component';
import {DashboardComponent} from '@pages/dashboard/dashboard.component';
import {AuthGuard} from '@guards/auth.guard';
import {NonAuthGuard} from '@guards/non-auth.guard';
import {ForgotPasswordComponent} from '@modules/forgot-password/forgot-password.component';
import {RecoverPasswordComponent} from '@modules/recover-password/recover-password.component';
import {MainMenuComponent} from '@pages/main-menu/main-menu.component';
import {SubMenuComponent} from '@pages/main-menu/sub-menu/sub-menu.component';
import { CoursesComponent } from '@pages/courses/courses.component';
import { CoursedetailComponent } from '@pages/courses/coursedetail/coursedetail.component';
import { LeveldetailComponent } from '@pages/courses/coursedetail/leveldetail/leveldetail.component';
import { PhasedetailComponent } from '@pages/courses/coursedetail/leveldetail/phasedetail/phasedetail.component';
import { KeywordComponent } from '@pages/courses/coursedetail/leveldetail/phasedetail/keyword/keyword.component';
import { AvatarComponent } from '@pages/avatar/avatar.component';
import { BlogListComponent } from '@pages/blog/blog-list/blog-list.component';
import { UsersComponent } from '@pages/users/users.component';
import { BadgeListComponent } from '@pages/badges/badge-list/badge-list.component';
import { PromptComponent } from '@pages/prompt/prompt.component';
import { GeminiBatchJobsComponent } from '@pages/gemini-batch-jobs/gemini-batch-jobs.component';
import { NotificationsPageComponent } from '@pages/notifications/notifications-page.component';
import { PremiumPageComponent } from '@pages/premium/premium-page.component';

const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
            {
                path: 'profile',
                component: ProfileComponent
            },
            {
                path: 'languages',
                component: BlankComponent
            },
            {
                path: 'courses',
                component: CoursesComponent
            },
            {
                path: 'coursedetail/:id',
                component: CoursedetailComponent
            },
            {
                path: 'leveldetail/:id',
                component: LeveldetailComponent
            },
            {
                path: 'phasedetail/:id',
                component: PhasedetailComponent
            },
            {
                path: 'keyword/:id',
                component: KeywordComponent
            },
            {
                path: 'avatars',
                component: AvatarComponent
            },
            {
                path: 'blog',
                component: BlogListComponent
            },
              {
                path: 'users',
                component: UsersComponent
            },
            {
                path: 'badges',
                component: BadgeListComponent
            },
            {
                path: 'prompts',
                component: PromptComponent
            },
            {
                path: 'gemini-batch-jobs',
                component: GeminiBatchJobsComponent
            },
            {
                path: 'notifications',
                component: NotificationsPageComponent
            },
            {
                path: 'premium',
                component: PremiumPageComponent
            },
            {
                path: '',
                component: DashboardComponent
            }
        ]
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'register',
        component: RegisterComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        canActivate: [NonAuthGuard]
    },
   
    {path: '**', redirectTo: ''}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule {}
